import styled from '@emotion/styled'

import { maxDeviceWidth } from '../../../../utils/mixins'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  margin-top: 50px;

  ${maxDeviceWidth(768)} {
    margin-top: 60px;
  }
`



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/PlacesToPlayIbcricket/PlacesListToPlayIbcricket/styledComponents.js